'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectWithoutProperties = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var axios = require('axios');

var _require = require('content-type'),
    parseContentType = _require.parse;

var qs = require('qs');

var defaultContentType = 'application/octet-stream';
var httpMethodsWithBodies = new Set(['put', 'post', 'delete', 'trace', 'patch']);
var env = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? 'dev' : 'prod';
var faasBaseUrl = env === 'prod' ? 'https://ssfy.sh' : 'http://localhost:5100';

module.exports = /*#__PURE__*/function () {
  function SaasifyFaasSDK() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SaasifyFaasSDK);

    if (typeof opts === 'string') {
      this._token = opts;
    } else {
      var token = opts.token,
          baseUrl = opts.baseUrl,
          targetUrl = opts.targetUrl,
          deploymentId = opts.deploymentId,
          projectId = opts.projectId;
      this._token = token;
      this._targetUrl = targetUrl;

      if (targetUrl && process.env.NODE_ENV === 'production') {
        console.warn('SaasifyFaasSDK ignoring "targetUrl" in production');
        this._targetUrl = undefined;
      }

      if (baseUrl) {
        this._baseUrl = baseUrl;
      } else if (deploymentId) {
        this._baseUrl = "".concat(faasBaseUrl, "/").concat(deploymentId);
      } else if (projectId) {
        this._baseUrl = "".concat(faasBaseUrl, "/").concat(projectId);
      } else {
        this._baseUrl = faasBaseUrl;
      }
    }
  }

  _createClass(SaasifyFaasSDK, [{
    key: "get",
    // --------------------------------------------------------------------------
    // Call
    // --------------------------------------------------------------------------
    value: function get(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.call(url, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'GET'
      }));
    }
  }, {
    key: "put",
    value: function put(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.call(url, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'PUT'
      }));
    }
  }, {
    key: "post",
    value: function post(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.call(url, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'POST'
      }));
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.call(url, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'DELETE'
      }));
    }
  }, {
    key: "head",
    value: function head(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.call(url, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'HEAD'
      }));
    }
  }, {
    key: "patch",
    value: function patch(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.call(url, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'PATCH'
      }));
    }
  }, {
    key: "trace",
    value: function trace(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.call(url, _objectSpread(_objectSpread({}, opts), {}, {
        method: 'TRACE'
      }));
    }
  }, {
    key: "call",
    value: function () {
      var _call = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, _ref) {
        var data, _ref$method, method, _ref$headers, headers, rest, hasBody, authHeaders, payload, options, res, contentType, contentTypeParsed, body, message, err;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _ref.data, _ref$method = _ref.method, method = _ref$method === void 0 ? 'POST' : _ref$method, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers, rest = _objectWithoutProperties(_ref, ["data", "method", "headers"]);

                if (!rest.url) {
                  _context.next = 3;
                  break;
                }

                throw new Error('saasify-faas-sdk found invalid use of "url": suggest using the second parameter { data: { url } }');

              case 3:
                hasBody = httpMethodsWithBodies.has(method.toLowerCase());
                authHeaders = {};
                payload = {};

                if (this._token) {
                  authHeaders.authorization = this._token;
                }

                if (data !== undefined) {
                  if (hasBody) {
                    payload.data = data;
                  } else {
                    payload.params = data;
                  }
                }

                if (this._targetUrl) {
                  headers['x-saasify-target'] = this._targetUrl;
                }

                options = _objectSpread(_objectSpread({
                  baseURL: this._baseUrl,
                  url: url,
                  method: method,
                  headers: _objectSpread(_objectSpread({
                    'content-type': 'application/json'
                  }, authHeaders), headers),
                  responseType: 'arraybuffer',
                  validateStatus: function validateStatus(status) {
                    return true;
                  },
                  paramsSerializer: function paramsSerializer(params) {
                    return qs.stringify(params);
                  }
                }, payload), rest);
                _context.next = 12;
                return axios.request(options);

              case 12:
                res = _context.sent;

                if (!(res.status === 429)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", {
                  hitRateLimit: true,
                  response: res
                });

              case 15:
                contentType = res.headers['content-type'] || defaultContentType;
                contentTypeParsed = parseContentType(contentType);
                body = Buffer.from(res.data, 'binary'); // TODO: switch to use type-is package here

                if (contentType.startsWith('text/')) {
                  body = body.toString();
                } else if (contentType.startsWith('application/json')) {
                  body = JSON.parse(body.toString());
                } else if (contentType.startsWith('image/')) {// return raw binary buffer as-is
                } else {// TODO: gracefully handle other content-types
                  }

                if (!(res.status >= 200 && res.status < 300)) {
                  _context.next = 23;
                  break;
                }

                return _context.abrupt("return", {
                  body: body,
                  contentType: contentType,
                  contentTypeParsed: contentTypeParsed,
                  response: res
                });

              case 23:
                message = typeof body === 'string' ? body : "Request failed with status code ".concat(res.status);
                err = new Error(message);
                err.response = res;
                throw err;

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function call(_x, _x2) {
        return _call.apply(this, arguments);
      }

      return call;
    }()
  }, {
    key: "isAuthenticated",
    get: function get() {
      return !!this._token;
    }
  }, {
    key: "token",
    get: function get() {
      return this._token;
    },
    set: function set(token) {
      this._token = token;
    }
  }]);

  return SaasifyFaasSDK;
}();